<template>
    <div class="automation-landing-card" :data-bot="dataBot" @click="handleClick">
        <CompassIcon :icon="icon" size="extra-large" />
        <div class="automation-landing-card-content">
            <div class="automation-landing-card__header">
                <p class="automation-landing-card__title typographies-paragraph-large-semibold">
                    {{ title }}
                </p>
            </div>
            <p class="automation-landing-card__caption typographies-paragraph-medium-regular">
                {{ caption }}
            </p>
        </div>
        <CompassIconButton
            icon="arrow-right"
            class="automation-landing-card__arrow-button"
            @click.stop="handleClick"
        />
    </div>
</template>

<script>
export default {
    name: 'AutomationLandingCard',
    props: {
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        caption: {
            type: String,
            required: true,
        },
        dataBot: {
            type: String,
            default: null,
        },
    },
    emits: ['click'],
    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-landing-card {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    padding: var(--spacing-3);
    border: 1px solid var(--colors-common-border-standard-default);
    border-radius: var(--spacing-1);
    cursor: pointer;
    background: var(--colors-common-background-default);
    box-shadow: var(--elevation-1);
    transition: all 0.2s ease-in-out;
    position: relative;

    &:hover {
        transform: translateY(-4px);

        .automation-landing-card__arrow-button {
            opacity: 1;
            visibility: visible;
        }
    }

    &__arrow-button {
        opacity: 0;
        visibility: hidden;
        transition:
            opacity 0.2s ease-in-out,
            visibility 0.2s ease-in-out;
        margin-left: auto;
    }
    &__tooltip {
        &:deep(.compass-tooltip__element) {
            width: 100%;
        }
    }
    &__header {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }
    &__title {
        margin: 0;
        color: var(--colors-common-text-standard-default);
    }
    &__caption {
        margin: 0;
        color: var(--colors-common-text-standard-caption);
    }
}
.automation-landing__card-header {
    display: flex;
    align-items: center;
    gap: var(--spacing-2);
}
</style>
